import styled from 'styled-components';
import { mx, my } from '@lendi-ui/spacing';

export const Figure = styled.figure`
  ${mx('nil')}
  ${my('md')}
  height: 50vw;
  max-height: 27rem;
`;

export const Video = styled.video`
  width: 100%;
  height: 100%;
`;

export const Iframe = styled.iframe`
  width: 100%;
  height: 100%;
`;
